import { render, staticRenderFns } from "./EditImageModal.vue?vue&type=template&id=6b78d284&scoped=true&"
import script from "./EditImageModal.vue?vue&type=script&lang=js&"
export * from "./EditImageModal.vue?vue&type=script&lang=js&"
import style0 from "./EditImageModal.vue?vue&type=style&index=0&id=6b78d284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78d284",
  null
  
)

export default component.exports